export default {
    init() {
        console.log('Latest Thinking');
        // ONLY SHOW the signup once every 6 months or so after 10 seconds
        if (document.cookie.indexOf('shownPopup') < 1) {
            $(window).load(function () {
                setTimeout(function () {
                    $('.newsletter-signup').modal('show');
                    var now = new Date();
                    var time = now.getTime();
                    var expireTime = time + (3600000 * 24 * 365) / 2 + 0.5; // 183 days (around half a yeeeeaaaaar - pirate);
                    now.setTime(expireTime);
                    document.cookie =
                        'shownPopup=1;expires=' + now.toGMTString() + ';path=/';
                }, 5000);
            });
        }
    },
    finalize() {},
};
